// import React, { useEffect, useState } from "react";
// import pharmacyLedgerService from "../../Services/pharmacyledger";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

// const SalesPurchaseLedger = () => {
//   const [ledgerData, setLedgerData] = useState([]);
//   const [totals, setTotals] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");

//   const [filterType, setFilterType] = useState("All");

//   const fetchLedger = async (start = "", end = "") => {
//     try {
//       setLoading(true);

//       const params = {};
//       if (start) params.startDate = start;
//       if (end) params.endDate = end;

//       console.log("📅 Fetching ledger with params:", params);

//       const response = await pharmacyLedgerService.getSummary(params);

//       if (response && response.success) {
//         setLedgerData(response.data || []);
//         setTotals(response.totals || {});
//       } else {
//         setLedgerData([]);
//         setTotals({});
//       }
//     } catch (error) {
//       console.error("❌ Error fetching ledger:", error);
//       setLedgerData([]);
//       setTotals({});
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (!startDate && !endDate) {
//       fetchLedger();
//     } else if (startDate && endDate) {
//       fetchLedger(startDate, endDate);
//     }
//   }, [startDate, endDate]);

//   const filteredLedger = ledgerData.filter((item) => {
//     if (filterType === "Purchased") {

//       return Number(item.total_purchase_qty) > 0;
//     }
//     if (filterType === "Sold") {

//       return Number(item.total_sale_qty) > 0;
//     }
//     return true;
//   });

//   const handleDownload = () => {
//     if (filteredLedger.length === 0) return;

//     const wsData = [
//       ["Medicine", "Purchased Qty", "Sold Qty", "Balance Qty", "Purchase Value", "Sales Value", "Balance Value"],
//       ...filteredLedger.map((item) => [
//         item.medicine_name,
//         item.total_purchase_qty,
//         item.total_sale_qty,
//         item.balance_qty,
//         Number(item.total_purchase_value).toFixed(2),
//         Number(item.total_sale_value).toFixed(2),
//         Number(item.balance_value).toFixed(2),
//       ]),
//       [
//         "***Total",
//         totals.total_purchase_qty,
//         totals.total_sale_qty,
//         totals.total_balance_qty,
//         Number(totals.total_purchase_value).toFixed(2),
//         Number(totals.total_sale_value).toFixed(2),
//         Number(totals.total_balance_value).toFixed(2),
//       ],
//     ];

//     const ws = XLSX.utils.aoa_to_sheet(wsData);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Ledger");
//     const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//     saveAs(new Blob([wbout], { type: "application/octet-stream" }), `ledger_${Date.now()}.xlsx`);
//   };

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center h-screen">
//         <p className="text-gray-600 text-lg font-semibold">Loading Ledger...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-50 py-4">
//       <div className="flex justify-center items-center">
//         <div className="bg-white shadow-lg p-8 w-[90%] mt-2 border border-gray-300 rounded-3xl">
//           <div className="flex flex-col">
//             <h1 className="text-primary text-2xl font-bold">Sales And Purchase Ledger</h1>
//             <p className="text-base text-gray-500 font-semibold mt-2">
//               Medicine Stock Summary (Purchase, Sale & Balance)
//             </p>
//           </div>
//         </div>
//       </div>

//       <div className="flex flex-col justify-center items-center mt-10">

//         <div className="flex flex-row gap-12 justify-end w-[90%]">

//           <div className="flex gap-3 items-center">
//             <label className="text-md text-gray-700 font-bold">Show:</label>
//             <select
//               value={filterType}
//               onChange={(e) => setFilterType(e.target.value)}
//               className="border-b-2 border-gray-400 focus:outline-none focus:border-primary bg-transparent py-1"
//             >
//               <option value="All">All Records</option>
//               <option value="Purchased">Purchased qty</option>
//               <option value="Sold">Sold qty</option>
//             </select>
//           </div>

//           <div className="flex gap-3 items-center">
//             <label className="text-md text-gray-700 font-bold">Start Date:</label>
//             <input
//               type="date"
//               value={startDate}
//               onChange={(e) => setStartDate(e.target.value)}
//               className="border-b-2 border-gray-400 focus:outline-none focus:border-primary"
//             />
//           </div>
//           <div className="flex gap-3 items-center">
//             <label className="text-md text-gray-700 font-bold">End Date:</label>
//             <input
//               type="date"
//               value={endDate}
//               onChange={(e) => setEndDate(e.target.value)}
//               className="border-b-2 border-gray-400 focus:outline-none focus:border-primary"
//             />
//           </div>
//         </div>

//         <div className="w-[90%] mt-6 max-h-[65vh] overflow-y-auto border border-gray-300 rounded-lg shadow-inner bg-white relative">
//           <table className="w-full min-w-full border-separate border-spacing-y-4 table-auto text-left">
//             <thead className="sticky top-0 bg-gray-700 text-white z-20">
//               <tr className="uppercase text-sm leading-normal">
//                 <th className="p-3 text-left text-[13px]">Medicine</th>
//                 <th className="p-3 text-left text-[13px]">Purchased Qty</th>
//                 <th className="p-3 text-left text-[13px]">Sold Qty</th>
//                 <th className="p-3 text-left text-[13px]">Balance Qty</th>
//                 <th className="p-3 text-left text-[13px]">Purchase Value</th>
//                 <th className="p-3 text-left text-[13px]">Sales Value</th>
//                 <th className="p-3 text-left text-[13px]">Balance Value</th>
//               </tr>
//             </thead>

//             <tbody>

//               {filteredLedger.length > 0 ? (
//                 filteredLedger.map((item, index) => (
//                   <tr key={index} className="odd:bg-gray-50 even:bg-white">
//                     <td className="py-3 px-4 font-semibold text-primary">{item.medicine_name}</td>
//                     <td className="py-3 px-4">{item.total_purchase_qty}</td>
//                     <td className="py-3 px-4">{item.total_sale_qty}</td>
//                     <td className="py-3 px-4">{item.balance_qty}</td>
//                     <td className="py-3 px-4">{Number(item.total_purchase_value).toFixed(2)}</td>
//                     <td className="py-3 px-4">{Number(item.total_sale_value).toFixed(2)}</td>
//                     <td className="py-3 px-4">{Number(item.balance_value).toFixed(2)}</td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="7" className="text-center py-6 text-gray-500 font-medium">
//                     No ledger data found
//                   </td>
//                 </tr>
//               )}

//               {filteredLedger.length > 0 && (
//                 <tr className="font-bold bg-gray-200 border sticky bottom-0">
//                   <td className="py-3 px-4 text-right">Total:</td>
//                   <td className="py-3 px-4">{totals.total_purchase_qty}</td>
//                   <td className="py-3 px-4">{totals.total_sale_qty}</td>
//                   <td className="py-3 px-4">{totals.total_balance_qty}</td>
//                   <td className="py-3 px-4">{Number(totals.total_purchase_value).toFixed(2)}</td>
//                   <td className="py-3 px-4">{Number(totals.total_sale_value).toFixed(2)}</td>
//                   <td className="py-3 px-4">{Number(totals.total_balance_value).toFixed(2)}</td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//         {filteredLedger.length > 0 && (
//           <div className="flex justify-end w-[90%] mt-4">
//             <button
//               onClick={handleDownload}
//               className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white font-bold rounded-md"
//             >
//               Download Ledger
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default SalesPurchaseLedger;
import React, { useEffect, useState } from "react";
import pharmacyLedgerService from "../../Services/pharmacyledger";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const fmt = (n) => (isNaN(n) ? "0.00" : parseFloat(n).toFixed(2));

const SalesPurchaseLedger = () => {
  const [ledgerData, setLedgerData] = useState([]);
  const [totals, setTotals] = useState({});
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filterType, setFilterType] = useState("All");

  const fetchLedger = async (start = "", end = "") => {
    try {
      setLoading(true);
      const params = {};
      if (start) params.startDate = start;
      if (end) params.endDate = end;
      const response = await pharmacyLedgerService.getSummary(params);
      if (response?.success) {
        setLedgerData(response.data || []);
        setTotals(response.totals || {});
      } else {
        setLedgerData([]);
        setTotals({});
      }
    } catch (error) {
      setLedgerData([]);
      setTotals({});
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!startDate && !endDate) fetchLedger();
    else if (startDate && endDate) fetchLedger(startDate, endDate);
  }, [startDate, endDate]);

  const filteredLedger = ledgerData.filter((item) => {
    if (filterType === "Purchased") return Number(item.total_purchase_qty) > 0;
    if (filterType === "Sold") return Number(item.total_sale_qty) > 0;
    return true;
  });

  const handleDownload = () => {
    if (!filteredLedger.length) return;
    const wsData = [
      [
        "Medicine",
        "Purchased Qty",
        "Sold Qty",
        "Balance Qty",
        "Purchase Value",
        "Sales Value",
        "Balance Value",
      ],
      ...filteredLedger.map((item) => [
        item.medicine_name,
        item.total_purchase_qty,
        item.total_sale_qty,
        item.balance_qty,
        fmt(item.total_purchase_value),
        fmt(item.total_sale_value),
        fmt(item.balance_value),
      ]),
      [
        "***Total",
        totals.total_purchase_qty,
        totals.total_sale_qty,
        totals.total_balance_qty,
        fmt(totals.total_purchase_value),
        fmt(totals.total_sale_value),
        fmt(totals.total_balance_value),
      ],
    ];
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Ledger");
    saveAs(
      new Blob([XLSX.write(wb, { bookType: "xlsx", type: "array" })], {
        type: "application/octet-stream",
      }),
      `ledger_${Date.now()}.xlsx`,
    );
  };

  const colWidths = [
    "180px",
    "110px",
    "90px",
    "100px",
    "120px",
    "110px",
    "110px",
  ];
  const ColGroup = () => (
    <colgroup>
      {colWidths.map((w, i) => (
        <col key={i} style={{ width: w, minWidth: w }} />
      ))}
    </colgroup>
  );

  const kpiCards = [
    { label: "Purchase Qty", value: totals.total_purchase_qty ?? "—" },
    { label: "Sold Qty", value: totals.total_sale_qty ?? "—" },
    { label: "Balance Qty", value: totals.total_balance_qty ?? "—" },
    {
      label: "Purchase Value",
      value: `Rs.${fmt(totals.total_purchase_value)}`,
    },
    { label: "Sale Value", value: `Rs.${fmt(totals.total_sale_value)}` },
  ];

  return (
    <div className="p-3 sm:p-4 font-sans">
      {/* ── Header ── */}
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div>
          <p className="text-xs font-medium tracking-widest uppercase text-gray-500">
            Sales & Purchase Ledger
          </p>
          <p className="text-xs text-gray-400 mt-0.5">
            {filteredLedger.length} records found
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <select
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
            className="text-xs border border-gray-200 rounded-lg px-2.5 py-1.5 text-gray-700 bg-white focus:outline-none focus:ring-1 focus:ring-blue-100"
          >
            <option value="All">All Records</option>
            <option value="Purchased">Purchased Qty</option>
            <option value="Sold">Sold Qty</option>
          </select>
          <div className="flex items-center gap-1.5">
            <label className="text-xs text-gray-500">From</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="text-xs border border-gray-200 rounded-lg px-2.5 py-1.5 text-gray-700 bg-white focus:outline-none focus:ring-1 focus:ring-blue-100"
            />
          </div>
          <div className="flex items-center gap-1.5">
            <label className="text-xs text-gray-500">To</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="text-xs border border-gray-200 rounded-lg px-2.5 py-1.5 text-gray-700 bg-white focus:outline-none focus:ring-1 focus:ring-blue-100"
            />
          </div>
          <button
            onClick={handleDownload}
            className="text-[13px] border border-gray-200 rounded-lg px-8 py-3 bg-green-500 text-white hover:bg-green-600 focus:outline-none focus:ring-1 focus:ring-blue-100 flex items-center gap-1.5"
          >
            <svg
              className="w-3.5 h-3.5 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5 5-5M12 15V3"
              />
            </svg>
            Download
          </button>
        </div>
      </div>

      {/* ── KPI Cards ── */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2 sm:gap-3 mb-4">
        {kpiCards.map(({ label, value }) => (
          <div
            key={label}
            className="bg-gray-100 border border-gray-200 rounded-lg px-3 py-2.5"
          >
            <p className="text-[10px] tracking-wide text-gray-400 uppercase mb-1">
              {label}
            </p>
            <p className="text-base font-semibold text-gray-800">{value}</p>
          </div>
        ))}
        <div className="bg-gray-100 rounded-lg px-3 py-2.5 border-t-2 border-[#F07F1C] col-span-2 sm:col-span-3 lg:col-span-1">
          <p className="text-[10px] tracking-wide text-gray-400 uppercase mb-1">
            Balance Value
          </p>
          <p className="text-base font-bold text-[#F07F1C]">
            Rs.{fmt(totals.total_balance_value)}
          </p>
        </div>
      </div>

      {/* ══ MOBILE CARDS ══ */}
      <div className="block sm:hidden space-y-2">
        {loading ? (
          <div className="text-center py-10 text-gray-400 text-xs">
            Loading...
          </div>
        ) : filteredLedger.length === 0 ? (
          <div className="text-center py-10 text-gray-400 text-xs">
            No ledger data found
          </div>
        ) : (
          <>
            {filteredLedger.map((item, index) => (
              <div
                key={index}
                className="border border-gray-200 rounded-xl bg-white px-3 py-3"
              >
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-[11px] font-semibold text-gray-600 uppercase flex-shrink-0">
                    {item.medicine_name?.charAt(0) || "M"}
                  </div>
                  <p className="text-[12px] font-semibold text-gray-800">
                    {item.medicine_name}
                  </p>
                </div>
                <div className="divide-y divide-gray-100">
                  {[
                    { label: "Purchase Qty", value: item.total_purchase_qty },
                    { label: "Sold Qty", value: item.total_sale_qty },
                    { label: "Balance Qty", value: item.balance_qty },
                    {
                      label: "Purchase Val",
                      value: `Rs.${fmt(item.total_purchase_value)}`,
                    },
                    {
                      label: "Sale Val",
                      value: `Rs.${fmt(item.total_sale_value)}`,
                    },
                    {
                      label: "Balance Val",
                      value: `Rs.${fmt(item.balance_value)}`,
                    },
                  ].map(({ label, value }) => (
                    <div key={label} className="flex justify-between py-1.5">
                      <span className="text-[11px] text-gray-400 w-24">
                        {label}
                      </span>
                      <span className="text-[11px] text-gray-700 text-right">
                        {value}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
            <div className="mt-3 bg-[#215187] rounded-xl px-3 py-3">
              {[
                {
                  label: "Total Purchase Qty",
                  value: totals.total_purchase_qty,
                },
                { label: "Total Sold Qty", value: totals.total_sale_qty },
                { label: "Total Balance Qty", value: totals.total_balance_qty },
                {
                  label: "Purchase Value",
                  value: `Rs.${fmt(totals.total_purchase_value)}`,
                },
                {
                  label: "Sale Value",
                  value: `Rs.${fmt(totals.total_sale_value)}`,
                },
              ].map(({ label, value }) => (
                <div
                  key={label}
                  className="flex justify-between py-1.5 border-b border-white/10 last:border-0"
                >
                  <span className="text-[12px] text-gray-400">{label}</span>
                  <span className="text-[12px] text-gray-100 font-medium">
                    {value}
                  </span>
                </div>
              ))}
              <div className="flex justify-between pt-2 mt-1 border-t border-white/20">
                <span className="text-[12px] font-medium text-gray-100">
                  Balance Value
                </span>
                <span className="text-[14px] font-bold text-[#F07F1C]">
                  Rs.{fmt(totals.total_balance_value)}
                </span>
              </div>
            </div>
          </>
        )}
      </div>

      {/* ══ DESKTOP TABLE ══ */}
      <div className="hidden sm:block border rounded-xl overflow-hidden">
        <div className="overflow-y-auto" style={{ maxHeight: "520px" }}>
          <table
            className="w-full text-sm"
            style={{
              tableLayout: "fixed",
              borderCollapse: "separate",
              borderSpacing: 0,
            }}
          >
            <ColGroup />
            <thead>
              <tr>
                {[
                  "Medicine",
                  "Purchase Qty",
                  "Sold Qty",
                  "Balance Qty",
                  "Purchase Value",
                  "Sale Value",
                  "Balance Value",
                ].map((label, i) => (
                  <th
                    key={label}
                    className={`sticky top-0 z-20 bg-[#215187] text-left px-4 py-2.5 text-[11px] text-gray-100 uppercase font-medium ${i < 6 ? "border-r border-white/10" : ""}`}
                  >
                    {label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td
                    colSpan={7}
                    className="text-center py-10 text-gray-400 text-[12px]"
                  >
                    Loading...
                  </td>
                </tr>
              ) : filteredLedger.length === 0 ? (
                <tr>
                  <td
                    colSpan={7}
                    className="text-center py-10 text-gray-400 text-[12px]"
                  >
                    No ledger data found
                  </td>
                </tr>
              ) : (
                filteredLedger.map((item, index) => (
                  <tr
                    key={index}
                    className={`border-b border-gray-100 hover:bg-green-50 transition-colors ${index % 2 ? "bg-gray-50" : "bg-white"}`}
                  >
                    <td className="px-4 py-2.5 border-r border-gray-100">
                      <span className="text-[12px] font-medium text-gray-800 truncate">
                        {item.medicine_name}
                      </span>
                    </td>
                    <td className="px-4 py-2.5 text-[12px] text-gray-600 border-r border-gray-100">
                      {item.total_purchase_qty}
                    </td>
                    <td className="px-4 py-2.5 text-[12px] text-gray-600 border-r border-gray-100">
                      {item.total_sale_qty}
                    </td>
                    <td className="px-4 py-2.5 text-[12px] text-gray-600 border-r border-gray-100">
                      {item.balance_qty}
                    </td>
                    <td className="px-4 py-2.5 text-[12px] text-gray-600 border-r border-gray-100">
                      Rs.{fmt(item.total_purchase_value)}
                    </td>
                    <td className="px-4 py-2.5 text-[12px] text-gray-600 border-r border-gray-100">
                      Rs.{fmt(item.total_sale_value)}
                    </td>
                    <td className="px-4 py-2.5 text-[12px] font-medium text-gray-800">
                      Rs.{fmt(item.balance_value)}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
            <tfoot>
              <tr className="bg-[#1F2937]">
                <td className="sticky bottom-0 z-20 bg-[#215187] px-4 py-2.5 text-[12px] font-medium text-gray-100 border-r border-white/10 border-t">
                  Grand Total
                </td>
                <td className="sticky bottom-0 z-20 bg-[#215187] px-4 py-2.5 text-[12px] text-gray-100 border-r border-white/10 border-t">
                  {totals.total_purchase_qty}
                </td>
                <td className="sticky bottom-0 z-20 bg-[#215187] px-4 py-2.5 text-[12px] text-gray-100 border-r border-white/10 border-t">
                  {totals.total_sale_qty}
                </td>
                <td className="sticky bottom-0 z-20 bg-[#215187] px-4 py-2.5 text-[12px] text-gray-100 border-r border-white/10 border-t">
                  {totals.total_balance_qty}
                </td>
                <td className="sticky bottom-0 z-20 bg-[#215187] px-4 py-2.5 text-[12px] text-gray-100 border-r border-white/10 border-t">
                  Rs.{fmt(totals.total_purchase_value)}
                </td>
                <td className="sticky bottom-0 z-20 bg-[#215187] px-4 py-2.5 text-[12px] text-gray-100 border-r border-white/10 border-t">
                  Rs.{fmt(totals.total_sale_value)}
                </td>
                <td className="sticky bottom-0 z-20 bg-[#215187] px-4 py-2.5 text-[12px] font-semibold text-[#F07F1C] border-t border-white/10">
                  Rs.{fmt(totals.total_balance_value)}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SalesPurchaseLedger;
